export const FOOD_TYPE = 'food';
export const NON_FOOD_TYPE = 'non-food';
export const MULTIPACK_TYPE = 'multipack';
export const NAME_PRIVATE_BRAND = 'privateBrandProduct';
export const NAME_COMPETITIVE_BRAND = 'competitiveBrandProduct';
export const NAME_COMPARATIVE_BRAND = 'comparativeAttachment';
